/** @format */

import React from 'react';
import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import UsersDropdown from 'features/policies/components/UsersDropdown';

interface UserSelectionProps {
  onUserChange: (userId: string | null) => void;
  selectedUserId?: string | null;
}

export const UserSelection: React.FC<UserSelectionProps> = ({ onUserChange, selectedUserId }) => {
  // Get office ID from user data
  const userData = useSelector((state: RootState) => (state.user as any).userData);
  const officeId = userData?.officeId;

  return (
    <>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-heading'>
          <span>User</span>
        </div>
      </Col>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-input-wrapper'>
          <label>
            Choose an agent you're submitting this form on their behalf (if it's you leave it blank)
          </label>
          <div style={{ marginTop: '10px' }}>
            <UsersDropdown
              officeId={officeId || ''}
              value={selectedUserId || undefined}
              onChange={(userId) => onUserChange(userId || null)}
            />
          </div>
        </div>
      </Col>
    </>
  );
};
